import { YjsEditor } from '@slate-yjs/core'
import { useEffect } from 'react'
import { type Editor } from 'slate'

export function useYjsConnection(editor: Editor) {
  useEffect(() => {
    if ('connect' in editor) {
      YjsEditor.connect(editor)
      // YjsEditor.connect populates editor.children synchronously and calls
      // editor.onChange(), but at this point Slate's parent effect has not yet
      // registered its EDITOR_TO_ON_CHANGE listener (child effects run first),
      // so the notification is dropped and the editor renders empty in
      // readOnly mode (no autofocus to trigger a later re-render). Schedule
      // another onChange after all mount effects have flushed.
      const timeout = setTimeout(() => editor.onChange(), 0)
      return () => {
        clearTimeout(timeout)
        YjsEditor.disconnect(editor)
      }
    }
  }, [editor])
}
